import gql from 'graphql-tag';

const DISABLE_USER = gql`
  mutation disableDashboardUser($id: ID!) {
    disableDashboardUser(where: { id: $id }) {
      id
      name
      username
      email
      phone
      cognitoUserId
      config {
        id
        providersVisible
        isAdmin
        isPartner
        isTrafficker
        exportData
        isSelfService
        hasInsights
        priceVisible
        isProcessor
        canResetPasswords
        campaignSummary
        isPacing
        pastData
        segment
        articles
        amplify
        configurator
        billing
        sitesAppsTransactions
        isBeta
      }
      roles(first: 5) {
        id
        roleItems(first: 20) {
          id
          feature
          actions
        }
        org {
          id
          name
          config {
            priceVisible
            providersVisible
            isPartner
            isTrafficker
            isSelfService
            hasInsights
            isAdmin
            exportData
            isProcessor
            canResetPasswords
            campaignSummary
            isPacing
            pastData
            segment
            articles
            amplify
            configurator
            billing
            sitesAppsTransactions
            isBeta
          }
          parentOrg {
            id
            name
          }
          logo {
            id
            key
          }
        }
      }
      avatar {
        id
        key
      }
    }
  }
`;

export default DISABLE_USER;
